import React, { useState } from "react";
import { StaticVariables } from "../../../Utils/StaticVariables";
import { FiMail, FiMessageSquare } from "react-icons/fi";
import "./Tutorials.css";
import { useLocation } from "react-router-dom";

interface VideoProps {
  src: string;
  description: string;
  thumbnail?: string;
}

const VideoContainer: React.FC<VideoProps> = ({ src, description }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="tutorial-video-container">
      <div className="tutorial-video">
        {isLoading && <div className="video-loader" />}
        <div
          style={{ position: "relative", paddingBottom: "64.67%", height: 0 }}
        >
          <iframe
            src={src}
            frameBorder="0"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            onLoad={() => setIsLoading(false)}
          />
          </div>

        </div>
      <p className="tutorial-video-description">
        <b>{description}</b>
      </p>
    </div>
  );
};



const Tutorials = () => {
  const location = useLocation();

  return (
    <div className={location.pathname === '/tutorials' ? "tutorials-container-mobile" : " tutorials-container"}>
      <h1 className="dashboard-mobile-hide" style={{color: '#000'}}>
        {StaticVariables().TUTORIALS_TITLE}
      </h1>
      <div className="tutorials-content">
        <div className="tutorial-section">
          <h2 className="tutorial-section-header">Getting Started</h2>
          <p className="tutorial-section-subtext">
            Learn the basics of using Bubble and set up your first page
          </p>
          <div className="tutorial-videos-grid">
            <VideoContainer
              src="https://www.loom.com/embed/81a04fa5133f4a78bf6b251d71b3e128?sid=a0709959-b314-42b7-8d7d-dc63e028ba71?hideEmbedTopBar=true&hide_speed=true&hide_owner=true&hide_title=true&hide_share=true"
              description="Welcome to Search Bubble"
              thumbnail="https://cdn.loom.com/sessions/thumbnails/81a04fa5133f4a78bf6b251d71b3e128-10d3884602293c52-full.jpg"
            />
            <VideoContainer
              src="https://www.loom.com/embed/182eb6e33ac546bc8b29314c62429d1a?sid=65db8e4a-ca6c-4559-b710-f04c311bec7?hideEmbedTopBar=true&hide_speed=true&hide_owner=true&hide_title=true&hide_share=true"
              description="How to Set Up Your Landing Page"
              thumbnail="https://cdn.loom.com/sessions/thumbnails/182eb6e33ac546bc8b29314c62429d1a-53563c28768ae231-full.jpg"
            />
          </div>
        </div>

        <div className="tutorial-section">
          <h2 className="tutorial-section-header">
            How We Process Your Content
          </h2>
          <p className="tutorial-section-subtext">
            Learn how we process your content to ensure it's ready for your
            audience
          </p>

          <div className="tutorial-videos-grid">
            <VideoContainer
              src="https://www.loom.com/embed/8c0cc3c12fc14880b0635c2b9409385c?sid=1ae33546-bfc9-4fb0-8b84-8ae375ee8e29?hideEmbedTopBar=true&hide_speed=true&hide_owner=true&hide_title=true&hide_share=true"
              description="How We Process Your Instagram Posts"
              thumbnail="https://cdn.loom.com/sessions/thumbnails/8c0cc3c12fc14880b0635c2b9409385c-af3c0cf3aa97c52e-full.jpg"
            />
            <VideoContainer
              src="https://www.loom.com/embed/9c110cd3d90841b9956c15a637d81098?sid=eca5672b-e2ce-4279-9293-917c15df9d20?hideEmbedTopBar=true&hide_speed=true&hide_owner=true&hide_title=true&hide_share=true"
              description="How We Process Your Instagram Stories"
              thumbnail="https://cdn.loom.com/sessions/thumbnails/9c110cd3d90841b9956c15a637d81098-0ddb1e7d4869cb6a-full.jpg"
            />
            <VideoContainer
              src="https://www.loom.com/embed/76c9382b44fa4764834b4b39cc371de9?sid=02a41b7e-2dcb-4e2e-ae93-8f3d043bd2ef?hideEmbedTopBar=true&hide_speed=true&hide_owner=true&hide_title=true&hide_share=true"
              description="How We Process Your YouTube Videos"
            />
          </div>
        </div>

        <div className="help-section">
          <h2>Still need help?</h2>
          <div className="contact-buttons">
            <a href="sms:+16502002584" className="contact-button">
              <FiMessageSquare />
              Text the Founder
            </a>
            <a
              href="mailto:support@searchbubble.com"
              className="contact-button"
            >
              <FiMail />
              Email Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tutorials;
